var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-dialog",
    {
      staticClass: "create-circle-dialog",
      attrs: { "md-active": _vm.visible },
      on: {
        "update:mdActive": function($event) {
          _vm.visible = $event
        },
        "update:md-active": function($event) {
          _vm.visible = $event
        }
      }
    },
    [
      _c("md-dialog-title", [_vm._v("Create New Circle")]),
      _vm._v(" "),
      _c(
        "md-dialog-content",
        [
          _c(
            "md-field",
            [
              _c("label", [_vm._v("Circle Name")]),
              _vm._v(" "),
              _c("md-input", {
                attrs: { required: "" },
                model: {
                  value: _vm.circle.name,
                  callback: function($$v) {
                    _vm.$set(_vm.circle, "name", $$v)
                  },
                  expression: "circle.name"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "md-field",
            [
              _c("label", [_vm._v("Circle Code(lowercase, no spaces)")]),
              _vm._v(" "),
              _c("md-input", {
                attrs: { rules: _vm.codeRules, required: "" },
                model: {
                  value: _vm.circle.short,
                  callback: function($$v) {
                    _vm.$set(_vm.circle, "short", $$v)
                  },
                  expression: "circle.short"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "md-field",
            [
              _c("label", [_vm._v("Circle Page URL")]),
              _vm._v(" "),
              _c("md-input", {
                attrs: { placeholder: "https://xxx.protopia.co", required: "" },
                on: {
                  input: function($event) {
                    _vm.circle.circlePageUrl = _vm.ensureHttpsScheme(
                      _vm.sanitizeUrl($event)
                    )
                  }
                },
                model: {
                  value: _vm.circle.circlePageUrl,
                  callback: function($$v) {
                    _vm.$set(_vm.circle, "circlePageUrl", $$v)
                  },
                  expression: "circle.circlePageUrl"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "md-field",
            [
              _c("label", [_vm._v("Action Page")]),
              _vm._v(" "),
              _c(
                "md-select",
                {
                  model: {
                    value: _vm.circle.actionPage,
                    callback: function($$v) {
                      _vm.$set(_vm.circle, "actionPage", $$v)
                    },
                    expression: "circle.actionPage"
                  }
                },
                [
                  _c("md-option", { attrs: { value: "null", disabled: "" } }, [
                    _vm._v("Select an option")
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.actionPageOptions, function(page, index) {
                    return _c(
                      "md-option",
                      { key: page.code, attrs: { value: page.code } },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(page.name) +
                            "\n                "
                        )
                      ]
                    )
                  })
                ],
                2
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "md-field",
            [
              _c("label", [_vm._v("Administrators (comma-separated)")]),
              _vm._v(" "),
              _c("md-input", {
                model: {
                  value: _vm.circle.administrators,
                  callback: function($$v) {
                    _vm.$set(_vm.circle, "administrators", $$v)
                  },
                  expression: "circle.administrators"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "md-dialog-actions",
        [
          _c(
            "md-button",
            {
              on: {
                click: function($event) {
                  return _vm.$emit("cancel")
                }
              }
            },
            [_vm._v("Cancel")]
          ),
          _vm._v(" "),
          _c(
            "md-button",
            {
              staticClass: "md-primary",
              attrs: { disabled: !_vm.isValid },
              on: { click: _vm.save }
            },
            [_vm._v("Save")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fb6e49c8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fb6e49c8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CreateCircle.vue
// module id = null
// module chunks = 